(ns frontend.view.components.top-performer-chart
  (:require
   [frontend.bootstrap.components :as rbs]
   [frontend.view.components.form.components.form-account :as form-account]))

(defn component
  [{:keys [color]} data]
  (let [{:keys [account cases]} data]
    [:div
     {:class "px-4 flex flex-col gap-4"}
     [:div
      [:div.d-flex.justify-content-center.dashboard-top-performer.text-center
       [:div.flex-no-grow
        (when account
          (if (:account/picture-url account)
            [form-account/account-circle
             {:account       account
              :is-modal?     false
              :center-block? true
              :classes       {:image "top-performer-chart__photo-image"
                              :text  "top-performer-chart__photo-text"}}]
            [:span.dashboard-owner-circle
             (str (first (:account/first-name account))
                  (first (:account/last-name account)))]))]]]
     [:div
      [:div.top-performer-chart__cases.text-center
       {:style {:color color}}
       (or cases 0)]]]))
